<template>
  <div :class="Fullscreen">
    <div class="row">
      <div class="col-12">
        <div class="card card-bottom-radius-8">
          <div class="card-header text-third" v-if="showHeader">
            <small v-if="showPaging">{{
              $lang.Common.DataTable.RecordsShow
            }}</small>
            <select
              class="mb-2 mb-sm-0"
              style="border: solid 1px #d9d9d9"
              v-model="cbxItemPerPage"
              v-on:change="ReloadCountPage()"
              v-if="showPaging"
            >
              <option value="5" selected>5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <small v-if="showPaging">{{
              $lang.Common.DataTable.Records
            }}</small>
            <div class="card-actions">
              <a
                class="d-inline-flex align-items-center gap-2 firstCustom"
                style="margin-right: 0.5rem !important"
                href="javascript:void(0);"
                v-if="showFirstCustom"
                v-b-tooltip.hover
                :title="showFirstCustom.text"
                v-on:click="FirstCustom"
              >
                <i
                  :class="[showFirstCustom.icon, 'text-third']"
                  style="font-size: 15px"
                ></i>
                <p class="text-toupper mb-0">{{ showFirstCustom.text }}</p>
              </a>
              <a
                class="d-inline-flex align-items-center gap-2 firstCustom"
                style="margin-right: 0.5rem !important"
                href="javascript:void(0);"
                v-if="showSecondCustom"
                v-b-tooltip.hover
                :title="showSecondCustom.text"
                v-on:click="SecondCustom"
              >
                <i
                  :class="[showSecondCustom.icon, 'text-third']"
                  style="font-size: 15px"
                ></i>
                <p class="text-toupper mb-0">{{ showSecondCustom.text }}</p>
              </a>
              <a
                href="javascript:void(0);"
                v-if="showBack"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Back"
                v-on:click="Back"
              >
                <i class="fas fa-undo text-third" style="font-size: 15px"></i>
              </a>
              <a
                href="javascript:void(0);"
                v-if="showNew"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.New"
                v-on:click="New"
              >
                <i
                  class="fas fa-plus-circle text-third"
                  style="font-size: 15px"
                ></i>
              </a>
              <a
                href="javascript:void(0);"
                v-if="showReload"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Reload"
                v-on:click="Reload"
              >
                <i
                  class="fas fa-sync-alt text-third"
                  style="font-size: 15px"
                ></i>
              </a>
              <a
                href="javascript:void(0);"
                v-show="showUpload"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Upload"
                v-on:click="Upload"
              >
                <i class="fas fa-file-import text-third"></i>
              </a>
              <a
                href="javascript:void(0);"
                v-if="showSearch"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Search"
                v-on:click="Search"
              >
                <i class="fas fa-search text-third" style="font-size: 15px"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="d-md-down-none"
                v-if="showPrint"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Print"
                v-on:click="Print"
              >
                <i class="fas fa-print text-third" style="font-size: 15px"></i>
              </a>
              <a
                href="javascript:void(0);"
                class="d-md-down-none"
                v-if="showDownload"
                v-b-tooltip.hover
                :title="$lang.Common.Buttons.Download"
                v-on:click="SaveFile"
              >
                <i
                  class="fas fa-cloud-download-alt text-third"
                  style="font-size: 15px"
                ></i>
              </a>
              <a
                href="javascript:void(0);"
                class="d-md-down-none"
                v-if="showFullscreen"
                v-on:click="Fullscreen"
              >
                <i
                  class="fas fa-expand-arrows-alt text-third"
                  style="font-size: 15px"
                  v-if="setFullscreen"
                  v-b-tooltip.hover
                  :title="$lang.Common.Buttons.Fullscreen"
                ></i>
                <i
                  class="fas fa-compress-arrows-alt text-third"
                  style="font-size: 15px"
                  v-if="!setFullscreen"
                  v-b-tooltip.hover
                  :title="$lang.Common.Buttons.ExitFullscreen"
                ></i>
              </a>
              <a
                href="javascript:void(0);"
                class="d-md-down-none"
                v-if="showClose"
                v-on:click="$emit('Closed')"
                v-b-tooltip.hover
                :title="'Fechar'"
              >
                <i class="fa fa-times-circle" style="font-size: 15px"></i>
              </a>
              <slot name="table-header-buttons"></slot>
            </div>
          </div>
          <div
            :class="[
              showHeader ? 'card-block table-responsive' : 'table-responsive',
            ]"
          >
            <table
              class="table table-hover"
              :style="[showHeader ? 'border: 1px solid #dcdede;' : '']"
            >
              <thead
                class="thead-third"
                style="border: solid 1px #0277bd; height: 44px"
              >
                <tr>
                  <!-- <th class="text-center" v-for="colTitle in columns" :key="colTitle">{{colTitle}}</th> -->
                  <th
                    class="text-center"
                    v-for="colTitle in columns"
                    :key="colTitle.name ? colTitle.name : colTitle"
                  >
                    <input
                      type="checkbox"
                      :checked="headerCheckboxChecked"
                      v-on:change="checkAll"
                      v-if="colTitle.checkbox"
                    />
                    <!-- v-model="headerCheckbox" -->
                    <span v-else>{{ colTitle }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="total <= 0 && loading && showPaging">
                  <tr v-for="index in 5" v-bind:key="index">
                    <td v-for="column in columns.length" v-bind:key="column" class="text-center">
                      <b-skeleton width="100%"></b-skeleton>
                    </td>
                  </tr>
                </template>
                <tr v-if="total <= 0 && !loading">
                  <td :colspan="columns.length" class="text-center">
                    {{ $lang.Common.DataTable.NoRecordsFound }}
                  </td>
                </tr>
                <!-- <tr v-if="loading">
                  <td
                    :colspan="columns.length"
                    class="text-center"
                    style="padding: 74px 0px 74px"
                  >
                    <h3 class="text-secundary">{{ $lang.Common.Loading }}!</h3>
                    <img :src="ImgLoading" alt="Loading" style="width: 32px" />
                  </td>
                </tr> -->
                <slot></slot>
              </tbody>
              <tfoot>
                <slot name="table-footer"></slot>
              </tfoot>
            </table>
            <TablePager
              class="mt-2"
              v-model="pagingIndex"
              @previous="PagingPrevious"
              @next="PagingNext"
              @to="LoadPage"
              :totalPages="totalPages"
            />
            <div v-if="showPaging">
              <small>{{ ShowDisplayingPaging }}</small>
            </div>
          </div>
          <div>
            <slot name="table-footer-buttons"></slot>
          </div>
        </div>
      </div>
    </div>
    <TableEditMessage
      :showMessage="showTipFooter"
      :message="messageTipFooter"
    />
  </div>
</template>
<script>
import TableEditMessage from './TableEditMessage'
import TablePager from './TablePager.vue'

export default {
  name: 'Tables',
  data () {
    return {
      pagingIndex: 0,
      pagingLimit: 10,
      totalPages: 0,
      total: 0,
      startTotal: 0,
      cbxItemPerPage: 10,
      objList: null,
      currentPage: 1,
      loading: true,
      setFullscreen: true,
      ImgLoading: process.env.BaseURL + '/static/img/loader.gif',
      headerCheckboxChecked: false
    }
  },
  components: {
    TableEditMessage,
    TablePager
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    showFirstCustom: {
      type: Object,
      required: false
    },
    showSecondCustom: {
      type: Object,
      required: false
    },
    showBack: {
      type: Boolean,
      required: false
    },
    showReload: {
      type: Boolean,
      required: false
    },
    showNew: {
      type: Boolean,
      required: false
    },
    showUpload: {
      type: Boolean,
      required: false
    },
    showSearch: {
      type: Boolean,
      required: false
    },
    showPrint: {
      type: Boolean,
      required: false
    },
    showDownload: {
      type: Boolean,
      required: false
    },
    showFullscreen: {
      type: Boolean,
      required: false
    },
    showTipFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    messageTipFooter: {
      type: String,
      required: false
    },
    showClose: {
      type: Boolean,
      required: false,
      default: false
    },
    showPaging: {
      type: Boolean,
      required: false,
      default: true
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ActivePrevious: function () {
      if (this.pagingIndex <= 0) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ActiveNext: function () {
      if (this.currentPage >= this.totalPages) {
        return 'disabled'
      } else {
        return ''
      }
    },
    ShowRecordStart: function () {
      if (this.currentPage <= 0) {
        return this.currentPage
      } else {
        return this.currentPage * this.pagingLimit - this.pagingLimit
      }
    },
    ShowTotalPagedRecord: function () {
      if (this.currentPage >= this.totalPages) {
        return this.total
      } else {
        return this.currentPage * this.pagingLimit
      }
    },
    ShowDisplayingPaging: function () {
      var msg = this.$lang.Common.DataTable.MessageDisplayingRecords.replace(
        '@START@',
        this.ShowRecordStart
      )
      msg = msg.replace('@END@', this.ShowTotalPagedRecord)
      msg = msg.replace('@TOTAL@', this.total)
      return msg
    }
  },
  mounted () {
    setInterval(() => {
      if (this.loading) this.loading = false
    }, 2500)
  },
  methods: {
    Clear () {
      this.objList = null
      this.$parent.objList = null
      this.pagingIndex = 0
      this.pagingLimit = 10
      this.totalPages = 0
      this.total = 0
      this.startTotal = 0
      this.cbxItemPerPage = 10
      this.currentPage = 1
    },
    LoadAll () {
      this.$emit('Load')
    },
    LoadStartTotalGrid (total) {
      this.total = total
    },
    LoadAllByData (response) {
      this.objList = null
      this.$parent.objList = null
      // this.loading = true
      this.loading = false

      if (response) {
        var result = response.data
        if (response.status === 200) {
          this.objList = result.content
          this.$parent.objList = result.content
          this.total = result.totalElements
          this.totalPages = result.totalPages
          this.pagingIndex = result.number
          this.pagingLimit = this.cbxItemPerPage
        }
      }
      this.loading = false
    },
    PagingNext () {
      var index = this.pageIndex + 1
      if (this.currentPage < this.totalPages) {
        this.pageIndex = index
        this.currentPage = this.currentPage + 1
        this.LoadPage(index + 1)
      }
    },
    PagingPrevious () {
      var index = this.pageIndex - 1
      if (this.currentPage > 0) {
        this.pageIndex = index
        this.currentPage = this.currentPage - 1
        this.LoadPage(index + 1)
      }
    },
    ActivePage (index) {
      if (index === this.currentPage) {
        return 'disabled'
      } else {
        return ''
      }
    },
    LoadPage (index) {
      this.currentPage = index
      this.pagingIndex = index - 1
      if (this.currentPage >= 0 && this.currentPage <= this.totalPages) {
        this.LoadAll()
      }
    },
    ReloadCountPage () {
      this.pagingLimit = this.cbxItemPerPage
      this.pagingIndex = 0
      this.currentPage = 1
      this.LoadAll()
    },
    Print () {
      // variable to hold all the css that we extract
      var css = ''
      var styletags = document.getElementsByTagName('style')

      // loop over all the style tags
      for (var i = 0; i < styletags.length; i++) {
        // extract the css in the current style tag
        css += styletags[i].innerHTML
      }

      var currentsheet = false // initialise a variable to hold a reference to the stylesheet we are currently extracting from
      // loop over all the external stylesheets
      for (i = 0; i < document.styleSheets.lenngth; i++) {
        currentsheet = document.styleSheets[i]
        // loop over all the styling rules in this external stylesheet
        for (var e = 0; e < currentsheet.cssRules.length; e++) {
          // extract all the styling rules
          css += currentsheet.cssRules[e].cssText
        }
      }

      var headstr =
        '<!DOCTYPE html><html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"><meta name="robots" content="noindex, nofollow"><title>SDS - Backoffice :: Impressão</title><link type="text/css" rel="stylesheet" media="print" href="//unpkg.com/bootstrap/dist/css/bootstrap.min.css"/><link href="static/css/style.min.css?1001" rel="stylesheet" media="print"><style>@media print \n{\n' +
        css +
        '\n body{ padding: 2px;} \n}</style></head>'
      var footstr = '</body>'
      var content =
        '<table class="table" style="border: 1px solid rgb(220, 222, 222);">' +
        this.$el.children['0'].children['0'].childNodes['0'].childNodes[2]
          .children['0'].innerHTML +
        '</table>'
      var print = window.open('about:blank')

      print.document.write(headstr + content + footstr)
      print.window.print()
      print.window.close()
    },
    SaveFile () {
      // const data = JSON.stringify(this.objList)
      // const fs = require('fs');
      // try { fs.writeFileSync('download.txt', data, 'utf-8'); }
      // catch(e) { alert('Failed to save the file !'); }
      this.$emit('SaveFile')
    },
    Fullscreen () {
      if (this.setFullscreen) {
        this.setFullscreen = false
      } else {
        this.setFullscreen = true
      }
      this.$emit('Fullscreen')
    },
    checkAll () {
      this.headerCheckboxChecked = !this.headerCheckboxChecked
      if (this.headerCheckboxChecked) this.$emit('allChecked')
      else this.$emit('allUnchecked')
    },
    Reload () {
      this.$emit('Reload')
    },
    New () {
      this.$emit('New')
    },
    FirstCustom () {
      this.$emit('FirstCustom')
    },
    SecondCustom () {
      this.$emit('SecondCustom')
    },
    Upload () {
      this.$emit('Upload')
    },
    Search () {
      this.$emit('Search')
    },
    Back () {
      this.$emit('Back')
    }
  }
}
</script>
<style lang="scss">
.firstCustom {
  gap: 0.5rem;
  width: fit-content !important;
  padding-left: 0.5rem !important;
  p {
    color: #006a5b;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 100%;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/Tables.vue